module.exports = __webpack_public_path__ + "static/media/android-icon.f565ebc6.png";